<div class="row" [class.last]="last()" (click)="select()">
  <app-radio [checked]="selected()" />
  <div class="label">{{label()}}</div>
</div>
